import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import About from './pages/About';
import BookClass from './pages/BookClass';
import Collaborations from './pages/Collaborations';
import OfferingsPage from './components/Offerings';
import "./App.css";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Define the routes */}
        <Route path="/book-class" element={<BookClass />} />
        <Route path="/about" element={<About />} />
        <Route path="/collaborations" element={<Collaborations />} />
        <Route path="/offerings" element={<OfferingsPage />} />
        
        {/* Redirect all other routes to '/about' (home page) */}
        <Route path="*" element={<About />} />
      </Routes>
    </Router>
  );
};

export default App;
